import {React, useState} from 'react';
import Button from './button.js';

export default function SiteDisplay(props) {
    const [swap, setSwap] = useState(false);
        let ToggleSwap = () => {
            setSwap(!swap);
        };

    return (
        <div className="displayer" onClick={ToggleSwap}>
            <div className={swap ? "hiddendisplay" : "sitedisplay"}>
                <div className="siteimage">
                    <img src={props.displayimage} alt={props.displayalt} />
                    <p>{props.displayemoji}</p>
                </div>
                <div className="briefdescription"><p class="bold">{props.briefdescription}</p></div>
            </div>
            <div className={swap ? "extendeddisplay" : "hiddendisplay"}>
                <div className="siteimage">
                    <img src={props.displayimage} alt={props.displayalt} />
                    <p>{props.displayemoji}</p>
                </div>
                <div className="extendedcontent">
                    <p>{props.extendedtext}</p>
                    <p>{props.replitwarning}</p>
                    <Button buttonsize="smallbutton" buttonID={props.displaybuttonID} 
                        buttonsource={props.displaybuttonsource} 
                        buttonclick={props.displaybuttonclick} 
                        buttonname="Show me!" 
                        buttontarget="_blank" />
                </div>
            </div>
        </div>
    )
}